﻿$.fn.dxCtrlTooltip = function custom_dxCtrlTooltip(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrltooltip dx-ctrl");
        this.createInstance(new cdxCtrlTooltip(this, option));
    }
    return this;
}

window.cdxCtrlTooltip = function (container, option) {
    var Me = this;
    if (typeof option.value == 'undefined') option.value = null;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return dx.option(name);
        }
        else {
            dx.option(name, value);
        }
    }

    var dx = null;
    var timerHide = null;
    function mConstruit() {
        container.empty();
        if (dx) dx.hide();
        var contentTemplate = option.contentTemplate
        option.contentTemplate = function (contentElement) {
            if (typeof contentTemplate != 'undefined') contentTemplate(contentElement)
            if (typeof option.isMenu != 'undefined' && option.isMenu) {
                contentElement.find(".dx-overlay-content").css("background-color", theme.backgroundcolorBase)
                contentElement.find(".dx-overlay-content").css("border", theme.border)
            }
            try {
                if (typeof option.showCloseButton == "undefined" || option.showCloseButton) {
                    var $Div = $("<div style='position:absolute;z-index:2000'/>");
                    switch (dx.option("position")) {
                        case "top": $Div.css({ "right": "-18px", "bottom": "-18px" }); break;
                        case "bottom": $Div.css({ "right": "-18px", "top": "-18px" }); break;
                        case "left": $Div.css({ "right": "-18px", "top": "-18px" }); break;
                        case "right": $Div.css({ "left": "-18px", "top": "-18px" }); break;
                        default: $Div.css({ "right": "-18px", "top": "-18px" }); break;
                    }
                    var ele = $Div.appendTo(contentElement.parent()).dxCtrlButton({
                        focusStateEnabled: false,
                        width: 50,
                        height: 50,
                        icon: "fas fa-times",
                        onClick: function () { dx.hide(); }
                    });
                }
            }
            catch (e) { }
            window.setTimeout(function () {
                var compoFocus = contentElement.find(".dxctrlfocus")
                if (compoFocus.length > 0) {
                    if (typeof compoFocus.getInstance != 'undefined' && compoFocus.getInstance() != null) { compoFocus.getInstance().focus(); }
                    else { }
                }
            }, 0)
        }

        dx = container.dxTooltip(option).dxTooltip("instance")
        dx.option("onHidden", function (e) {
            e.component.element().remove()
            if (option && typeof option.onHidden != 'undefined' && option.onHidden) option.onHidden(e);
        })
        dx.option("onContentReady", function (e) {
            if (typeof option.onContentReady != 'undefined') option.onContentReady(e);
        })
    }

    this.show = function () { if (dx) dx.show(); }
    this.hide = function () { if (dx) dx.hide(); }

    this.element = function () { return container; }
    this.component = function () { return dx }

    mConstruit();
}